import { create } from 'zustand'

interface PageTransitionStore {
  pageTransitionTo: string
  setPageTransitionTo: (option: string) => void
  isInitialLoad: boolean
  setIsInitialLoad: (option: boolean) => void
  hasHydrated: boolean
  setHasHydrated: (val: boolean) => void
}

export const usePageTransition = create<PageTransitionStore>((set) => ({
  pageTransitionTo: '',
  setPageTransitionTo: (option) => set({ pageTransitionTo: option }),
  isInitialLoad: true,
  setIsInitialLoad: (option) => set({ isInitialLoad: option }),
  hasHydrated: false,
  setHasHydrated: (val) => set({ hasHydrated: val }),
}))
